import React, { useState, useMemo,useContext } from "react";
import { Redirect, useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteCeecampaign } from "services/ConfigServices";
import { statusData, energyData } from "variables/lists/cee";
import useCEECampaignTable from "./useCEECampaignTable.js";
import CustomDeleteButton from "../CustomDeleteButton/CustomDeleteButton.js";
import UserService from "../../services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import {
  Navigate,
} from "react-router-dom";

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const useStyles = makeStyles(styles);

const RTCEECampaign = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const ceeadmin = permis.includes("cee_admin");
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;
  const { gridState, refreshTable, setSelectedCeecampaigns } = useCEECampaignTable();
  const [redirState, setRedirState] = useState(false);
  const [ceecampaignId, setCeecampaignId] = useState("");
  const [ceecampaignName, setCeecampaignName] = useState("");
  const [ceecampaignAdminVisibility, setCeecampaignAdminVisibility] = useState("");
  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/cee/selectedcee/",
        state: { ceecampaignId, ceecampaignName, ceecampaignAdminVisibility },
      }}
      state= {{ ceecampaignId, ceecampaignName, ceecampaignAdminVisibility }}
    />
  );

  let dataMarkets = gridState.data;

  const classes = useStyles();

  const columns = [
    {
      name: "Nom de la campagne",
      selector: (row) => row.parameters.name,
      sortable: true,
     // minWidth: "13rem",
    },
    {
      name: "Statut",
      selector: (row) => row.parameters.status,
      sortable: true,
     // maxWidth: "12rem",
      cell: (row) => row.parameters.status ?
        <div style={{ color: statusData.find((x) => x.id == row.parameters.status).color, fontWeight: "bold" }}>
          {statusData.find((x) => x.id == row.parameters.status).name}
        </div> : <></>
    },
    {
      name: "Date de début",
      sortable: true,
      selector: (row) => row.parameters.datebegin,
      //maxWidth: "10rem",
      cell: (row) =>
        row.parameters.datebegin && moment(row.parameters.datebegin).isValid()
          ? moment(row.parameters.datebegin).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "Date de fin",
      sortable: true,
      selector: (row) => row.parameters.dateend,
      //maxWidth: "10rem",
      cell: (row) =>
        row.parameters.dateend && moment(row.parameters.dateend).isValid()
          ? moment(row.parameters.dateend).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "Périmètre",
      selector: (row) => row.parameters.groups,
      sortable: true,
      cell: (row) => (
        <GroupCell>
          <div>{groupInfoListById["" + row.parameters.groups[0]]}</div>
        </GroupCell>
      ),
    },
    {
      name: "Nombre d'adhérents",
      selector: (row) => row.membershipcount,
      sortable: true,
      width: "8rem",
    },
    {
      name: "",
      sortable: false,
      width: "7rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Voir les détails de la campagne">
              <Button
                onClick={CeeCampaignDetail(row)}
                color={"info"}
                className={classes.actionButton}
              >
                <VisibilityIcon fontSize="large" />
              </Button>
            </Tooltip>
            {ceeadmin && (
              <CustomDeleteButton
                deleteTitle={"Suppression de la campagne"}
                deleteSubTitle={`Êtes-vous sûr de vouloir supprimer la campagne ${row.parameters.name} ?`}
                handleSupprimer={deleteCeeCampaignFunction(row)}
              />
            )}
          </div>
        </>
      ),
    },
  ];

  const CeeCampaignDetail = (row) => async () => {
    setCeecampaignId(row.id);
    setCeecampaignName(row.parameters.name);
    setCeecampaignAdminVisibility(row.parameters.hasadminvisibility)
    setRedirState(true);
  };

  const deleteCeeCampaignFunction = (row) => async () => {
    let obj = dataMarkets.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteCeecampaign(idSelected);
    axios
      .delete(url, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `La campagne ${obj.parameters.name} a été supprimée`
          );
          refreshTable();
        } 
        else 
        setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedCeecampaigns(selection.selectedRows);
  };

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucune campagne CEE à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        highlightOnHover
        pointerOnHover
        onRowClicked={(row) => {
          setCeecampaignId(row.id);
          setCeecampaignName(row.parameters.name);
          setCeecampaignAdminVisibility(row.parameters.hasadminvisibility);
          setRedirState(true);
        }}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      {redirecting}
    </>
  );
};

export default RTCEECampaign;
